import {Callout, Spinner, SpinnerSize, useTheme} from '@fluentui/react';
import {useTranslation} from 'react-i18next';
import React, {useEffect, useMemo, useState} from 'react';

export enum CalloutLoaderState {
	Hidden,
	Loading,
	Success,
	Fail,
}
export type CalloutLoaderProps = {
	isLoading: boolean;
};

export const CalloutLoader: React.FC<CalloutLoaderProps> = ({isLoading}) => {
	const {t} = useTranslation('components/calloutloader');
	const theme = useTheme();

	const [state, setState] = useState<CalloutLoaderState>(
		CalloutLoaderState.Hidden,
	);

	useEffect(() => {
		if (isLoading && state !== CalloutLoaderState.Loading) {
			setState(CalloutLoaderState.Loading);
		}
		if (!isLoading && state === CalloutLoaderState.Loading) {
			setState(CalloutLoaderState.Success);
			const timer = setTimeout(
				() => setState(CalloutLoaderState.Hidden),
				8 * 1000,
			);
			return () => clearTimeout(timer);
		}
	}, [isLoading]);

	const message = useMemo(() => {
		switch (state) {
			case CalloutLoaderState.Loading:
				return t('Loading');
			case CalloutLoaderState.Success:
				return t('Success');
			case CalloutLoaderState.Fail:
				return t('Fail');
			default:
				return '';
		}
	}, [state]);

	const fontColor = useMemo(() => {
		switch (state) {
			case CalloutLoaderState.Success:
				return theme.palette.white;
			default:
				return '';
		}
	}, [state]);

	const bgColor = useMemo(() => {
		switch (state) {
			case CalloutLoaderState.Success:
				return theme.palette.green;
			default:
				return '';
		}
	}, [state]);

	return (
		<Callout
			role='alertdialog'
			target={{left: window.innerWidth - 20, top: window.innerHeight / 4}} // Place it at the right side
			hidden={state === CalloutLoaderState.Hidden}
			isBeakVisible={false}
			backgroundColor={bgColor}
		>
			<div style={{padding: 20, color: fontColor}}>
				{state === CalloutLoaderState.Loading && (
					<Spinner size={SpinnerSize.medium} />
				)}
				<p>{message}</p>
			</div>
		</Callout>
	);
};
